var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 0.833344H2.00008C1.64646 0.833344 1.30732 0.973819 1.05727 1.22387C0.807224 1.47392 0.666748 1.81305 0.666748 2.16668V12.8333C0.666748 13.187 0.807224 13.5261 1.05727 13.7762C1.30732 14.0262 1.64646 14.1667 2.00008 14.1667H10.0001C10.3537 14.1667 10.6928 14.0262 10.9429 13.7762C11.1929 13.5261 11.3334 13.187 11.3334 12.8333V5.50001M6.66675 0.833344L11.3334 5.50001M6.66675 0.833344V5.50001H11.3334",
    stroke: "#4B6CB7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.5f8ae8f0e12beb30ed07c6ed3ada0e4a.svg";
export { ForwardRef as ReactComponent };